import React from 'react';
import ReactDOM from 'react-dom/client';
import MostEfficient from './MostEfficient';

const pageBody : HTMLElement  = document.getElementById('main') as HTMLElement;

if (pageBody) {

    //SHOULD HAVE A BETTER API PASE FALLBACK
    const apiBasePath = pageBody.getAttribute("data-apiBasePath") ?? "";


    const root = ReactDOM.createRoot(pageBody);

    root.render(
        <React.StrictMode>
            <MostEfficient></MostEfficient>
        </React.StrictMode>
    );

}
